<div class="min-h-screen">
  <div class="mx-auto">
    <p-toast />
    <div class="card text-center mb-12">
      <h1 class="text-4xl font-bold text-gray-800 dark:text-white mb-4">
        Envoi de fichiers
      </h1>
      <p class="text-lg text-gray-600 dark:text-gray-300 font-medium">
        Importez vos fichiers Excel pour traitement
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
      <app-file-upload-card [config]="workNotificationConfig"></app-file-upload-card>
      <app-file-upload-card [config]="workOrderConfig"></app-file-upload-card>
      <app-file-upload-card [config]="workOrderOperationsConfig"></app-file-upload-card>
    </div>
  </div>
</div>
